import { createApp } from 'vue'
import App from './App.vue'
import router from '../src/router/index'
import { createPersistedState } from 'pinia-plugin-persistedstate'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import '../src/style/index.scss'
import 'virtual:uno.css'
import { loadStyle } from './utils/util'
import { iconfontUrl, iconfontVersion } from '@/config/env'
import VueI18n from './lang'

// 动态加载阿里云字体库
iconfontVersion.forEach((ele: any) => {
	loadStyle(iconfontUrl.replace('$key', ele))
})

//存储
const pinia = createPinia()
pinia.use(
	createPersistedState({
		storage: localStorage,
		auto: true // 自动存储所有仓库数据到localStorage
	})
) //持久化

const app = createApp(App)
app.use(router)
app.use(pinia)
app.use(VueI18n)
app.use(ElementPlus, { locale: zhCn })

//动态注册element-plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
	app.component(key, component)
}

app.mount('#app')
